import { useEffect, useState } from "react";
import NFT from '../../assets/images/nft.png'
import React from "react";
import NFTItem from "../nft-item";

export default function Merge() {
    const listNFT = [
        {
            name: 'Lorem ipsum',
            id: 'nft1',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft2',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft3',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft4',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft5',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft6',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft7',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft8',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft9',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft10',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft11',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft12',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft13',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft14',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },
        {
            name: 'Lorem ipsum',
            id: 'nft15',
            tier: '01',
            price: '123,456,789.00',
            img: NFT,
            infor: "This is NFT'information"
        },

    ]
    const itemPerPage = 12
    const numberPage = Math.ceil(listNFT.length / itemPerPage)
    // const [tierFilter, settierFilter] = useState(true)
    // const [searchNFT, setSearchNFT] = useState()
    const [currentPage, setCurrentPage] = useState(0)
    const [pickedNFTInfor, setPickedNFTInfor] = useState({
        name: '',
        id: '',
        tier: '',
        infor: '',
    })
    const [listPick, setListPick] = useState([
        { id: '', img: '' },
        { id: '', img: '' },
        { id: '', img: '' },
        { id: '', img: '' },
    ])
    const [currentList, setCurrentList] = useState(() => (listNFT.slice(0, 12)))
   
    useEffect(() => {
        setCurrentList(() => {
            return listNFT.slice(currentPage * itemPerPage, (currentPage + 1) * itemPerPage)
        })
    }, [currentPage])

    function handleRemoveNFT(index) {
        function addToCurrentList(id) {
            const index = listNFT.findIndex((nft) => {
                return nft.id == id
            })
            setCurrentList([listNFT[index], ...currentList])
        }
        addToCurrentList(listPick[index].id)
        let fakeList = JSON.parse(JSON.stringify(listPick))
        fakeList[index] = { id: '', img: '' }
        setListPick(fakeList)
    }

    function pick(item) {
        function reUpdateCurrentList(item) {
            const index = currentList.findIndex((nft) => {
                return nft.id == item.id
            })
            if (index !== -1) {
                let newList = JSON.parse(JSON.stringify(currentList))
                if (index == 0) {
                    newList.shift();
                }
                else {
                    newList = [...currentList.slice(0, index), ...currentList.slice(index + 1)]
                }
                setPickedNFTInfor({
                    name:item.name,
                    id:item.id,
                    tier:item.tier,
                    infor:item.infor
                })
                setCurrentList(newList);
            }
        }
        const location = listPick.findIndex(item => item.id === '')
        if(location !== -1){
            reUpdateCurrentList(item)
            let fakeList = JSON.parse(JSON.stringify(listPick))
            fakeList[location] = {id: item.id, img: item.img}
            console.log(fakeList)
            setListPick(fakeList)
        }
     
    }
    function handlePrevPage() {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1)
        }
    }
    function handleNextPage() {
        if (currentPage < numberPage - 1) {
            setCurrentPage(currentPage + 1)
        }
    }
    return (
        <div className="w-full">
            <div className="w-full flex flex-col items-center sm:flex-row sm:justify-start sm:flex-nowrap  gap-[2.4rem]">
                <div className="mb-[4rem] min-w-[44rem]">
                    <div className="w-full grid grid-cols-2 gap-[4rem] relative">
                    <div className="w-[1rem] h-[4rem] bg-[#141B22] absolute top-1/2 left-[10rem] -translate-x-1/2 -translate-y-1/2">
                    </div>
                    <div className="w-[1rem] h-[4rem] bg-[#141B22] absolute top-1/2 right-[10rem] translate-x-1/2 -translate-y-1/2">
                    </div>
                    <div className="h-[1rem] w-[4rem] bg-[#141B22] absolute  left-1/2 top-[16.1rem] -translate-y-1/2 -translate-x-1/2">
                    </div>
                    <div className="h-[1rem] w-[4rem] bg-[#141B22] absolute  left-1/2 bottom-[16.1rem] translate-y-1/2 -translate-x-1/2">
                    </div>
                        {Array.from(Array(4), (e, i) => {
                            return (
                                <div key={i} className="w-[20rem] h-[32.2rem] border-[1rem] border-[#141B22] relative">
                                      {listPick[i]?.id ? <img onClick={() => handleRemoveNFT(i)} className="relative z-10" src={listPick[i]?.img} width={1000} height={1000} alt="" /> : ''}
                                    <div className="w-[1rem] h-[6rem] bg-[#141B22] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
                                    </div>
                                    <div className="h-[1rem] w-[6rem] bg-[#141B22] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
                                    </div>
                                  
                                </div>
                            )
                        })}

                    </div>
                </div>
                <div className=" sm:min-w-[20rem] sm:max-w-[40rem] w-full  ">
                    <div className="">
                        <h3 className="text-white mb-[2.4rem]">MERGE</h3>
                        <p className="mb-[2rem] text-[#C2C3C5] font-poppin text-[2rem] leading-[3rem] whitespace-pre-line"> luctus tristique odio vitae diam ac. Dignissim tempor ultrices interdum nulla porttitor vitae. In.</p>
                    </div>
                    <div className="w-full">
                        <button onClick={() => console.log('merging')} type={'button'} disabled={listPick.findIndex(item => item.id ==='') === -1 ? false : true} className={`sm:px-[4rem] sm:w-full sm:max-w-[29rem] w-[25rem] py-[1.6rem] bg-primary rounded-full font-bakbak text-[16px] active:bg-opacity-50 transition-all duration-300 text-black text-center`}>
                            Merge
                        </button>
                    </div>

                </div>
            </div>
            <div className=" w-full grid  grid-cols-2   md:grid-cols-3 gap-[3rem] sm:mt-0 mt-[4rem] ">
           
                {currentList.map((item, index) =>
                    <div onClick={() => pick(item)} key={index} className="cursor-pointer">
                        <NFTItem name={item.name} id={item.id} img={item.img} price={item.price} tier={item.tier} />
                    </div>
                )}
            </div>
            <div className="flex justify-end items-center gap-[1.6rem] mt-[5rem]">

                <div onClick={handlePrevPage} className={`prev bg-transparent relative cursor-pointer transition-all rotate-180 duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                    <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">
                    </div>
                </div>
                {
                    Array.from(Array(numberPage), (e, i) => {
                        return (
                            <div onClick={() => setCurrentPage(i)} key={i} className={`${currentPage === i ? 'text-primary bg-third' : 'text-white bg-transparent'} cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-third  border`}>
                                <p className={`text-[1.8rem] font-poppin `}>{i + 1}</p>
                            </div>
                        )
                    })
                }
                <div onClick={handleNextPage} className={` next  bg-transparent relative cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                    <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">

                    </div>
                </div>
            </div>

        </div>
    )
}

